import React from 'react';

export const Circles = () => (
    <div>
        <p/>
        <h2>Circles of Wisdom and Knowledge</h2>
        <p/>
    </div>
)
